/* 布局 */
//前台
import Layout from "@views/layout";

const langstationRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "langstation",
            name: "LANGSTATION",
            meta: {
                title: "",
                sort: 1,
            },
            component: () => import("@views/business/langstation/index.vue"),
            redirect: {
                name: "LANGSTATION_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "LANGSTATION_LIST",
                    meta: {
                        title: "",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/langstation/list.vue"),
                },
                                {
                    path: "add",
                    name: "LANGSTATION_ADD",
                    meta: {
                        title: "新增语言站点表",
                        parentPath: '/business/langstation/list',
                        operate: true,
                    },
                    component: () => import("@views/business/langstation/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "LANGSTATION_EDIT",
                    meta: {
                        title: "编辑语言站点表",
                        parentPath: '/business/langstation/list',
                        operate: true,
                    },
                    component: () => import("@views/business/langstation/form.vue"),
                },
                                        ],
    },


        ],
};

export default langstationRouter;
